import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/Videocam';

class VideocamIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default VideocamIcon;
